const breadcrumbsButtons = {
	buttons: {},
	refresh: () => { },

	add: buttonsArg => {
		buttonsArg = Array.isArray(buttonsArg) ? buttonsArg : [buttonsArg]
		const id = Tyan.getUuid()
		breadcrumbsButtons.buttons[id] = buttonsArg
		setTimeout(breadcrumbsButtons.refresh)
		return id
	},

	remove: id => {
		id && breadcrumbsButtons.buttons[id] && (delete breadcrumbsButtons.buttons[id], setTimeout(breadcrumbsButtons.refresh))
	}
}

export default breadcrumbsButtons